/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 400f04c7187f
 */

import * as z from "zod";
import { uploadPresetsUpdateUploadPreset } from "../../funcs/uploadPresetsUpdateUploadPreset.js";
import { UploadPresetInput$zodSchema } from "../../models/uploadpresetinput.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  name: z.string().describe("The name of the upload preset."),
  upload_preset_input: UploadPresetInput$zodSchema.describe(
    `The updated upload preset configuration.`,
  ),
};

export const tool$uploadPresetsUpdateUploadPreset: ToolDefinition<typeof args> =
  {
    name: "update-upload-preset",
    description: `Updates an existing upload preset's configuration settings`,
    scopes: ["builder"],
    annotations: {
      "title": "Update Upload Preset",
      "destructiveHint": false,
      "idempotentHint": true,
      "openWorldHint": false,
      "readOnlyHint": false,
    },
    args,
    tool: async (client, args, ctx) => {
      const [result] = await uploadPresetsUpdateUploadPreset(
        client,
        args.name,
        args.upload_preset_input,
        { fetchOptions: { signal: ctx.signal } },
      ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      return formatResult(result.value);
    },
  };
